import ContactsService from '../../services/ContactsService';
import contactUseCase from './contactUseCase';

const contactFactory = contactUseCase({ ContactsService: ContactsService() });

export default contactFactory;
